webpackJsonp([114276838955818,60335399758886],{

/***/ 95:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"@fibasile blog","hero":{"title":"How to code (almost) anything","subtitle":"A blog about software, hardware and everything in between"}}}},"layoutContext":{}}

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(197);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(95);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _screenReaderStyles = __webpack_require__(445);
	
	var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false]Inverse the icon's color
	 * @param {String} name Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another
	 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	var FontAwesome = function (_React$Component) {
	  _inherits(FontAwesome, _React$Component);
	
	  function FontAwesome() {
	    _classCallCheck(this, FontAwesome);
	
	    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));
	
	    _this.displayName = 'FontAwesome';
	    return _this;
	  }
	
	  _createClass(FontAwesome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          border = _props.border,
	          cssModule = _props.cssModule,
	          className = _props.className,
	          fixedWidth = _props.fixedWidth,
	          flip = _props.flip,
	          inverse = _props.inverse,
	          name = _props.name,
	          pulse = _props.pulse,
	          rotate = _props.rotate,
	          size = _props.size,
	          spin = _props.spin,
	          stack = _props.stack,
	          _props$tag = _props.tag,
	          tag = _props$tag === undefined ? 'span' : _props$tag,
	          ariaLabel = _props.ariaLabel,
	          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	      var classNames = [];
	
	      if (cssModule) {
	        classNames.push(cssModule['fa']);
	        classNames.push(cssModule['fa-' + name]);
	        size && classNames.push(cssModule['fa-' + size]);
	        spin && classNames.push(cssModule['fa-spin']);
	        pulse && classNames.push(cssModule['fa-pulse']);
	        border && classNames.push(cssModule['fa-border']);
	        fixedWidth && classNames.push(cssModule['fa-fw']);
	        inverse && classNames.push(cssModule['fa-inverse']);
	        flip && classNames.push(cssModule['fa-flip-' + flip]);
	        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	        stack && classNames.push(cssModule['fa-stack-' + stack]);
	      } else {
	        classNames.push('fa');
	        classNames.push('fa-' + name);
	        size && classNames.push('fa-' + size);
	        spin && classNames.push('fa-spin');
	        pulse && classNames.push('fa-pulse');
	        border && classNames.push('fa-border');
	        fixedWidth && classNames.push('fa-fw');
	        inverse && classNames.push('fa-inverse');
	        flip && classNames.push('fa-flip-' + flip);
	        rotate && classNames.push('fa-rotate-' + rotate);
	        stack && classNames.push('fa-stack-' + stack);
	      }
	
	      // Add any custom class names at the end.
	      className && classNames.push(className);
	      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
	    }
	  }]);
	
	  return FontAwesome;
	}(_react2.default.Component);
	
	FontAwesome.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  border: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  cssModule: _propTypes2.default.object,
	  fixedWidth: _propTypes2.default.bool,
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  inverse: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  pulse: _propTypes2.default.bool,
	  rotate: _propTypes2.default.oneOf([90, 180, 270]),
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  spin: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  tag: _propTypes2.default.string
	};
	
	exports.default = FontAwesome;
	module.exports = exports['default'];

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  padding: '0px',
	  margin: '-1px',
	  overflow: 'hidden',
	  clip: 'rect(0px, 0px, 0px, 0px)',
	  border: '0px'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fiore = __webpack_require__(120);
	
	var _fiore2 = _interopRequireDefault(_fiore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bio = function (_React$Component) {
	  _inherits(Bio, _React$Component);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'media' },
	          _react2.default.createElement(
	            'div',
	            { className: 'media-left' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'image is-48x48' },
	              _react2.default.createElement('img', {
	                src: _fiore2.default,
	                alt: 'Fiore Basile'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media-content' },
	            _react2.default.createElement(
	              'p',
	              { className: 'title is-4' },
	              'Fiore Basile'
	            ),
	            'Creative, coder, digital fabrication expert and instructor living in Pisa, Italy and around the globe.',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about' },
	              'More about me'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	    _inherits(Hero, _React$Component);
	
	    function Hero() {
	        _classCallCheck(this, Hero);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Hero.prototype.render = function render() {
	        var heroTitle = void 0;
	        var heroSubtitle = void 0;
	        if (this.props.title) {
	            heroTitle = this.props.title;
	        }
	        if (this.props.subtitle) {
	            heroSubtitle = this.props.subtitle;
	        }
	        return _react2.default.createElement(
	            'section',
	            { className: 'hero is-light is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'title' },
	                        heroTitle
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'subtitle' },
	                        heroSubtitle
	                    )
	                )
	            )
	        );
	    };
	
	    return Hero;
	}(_react2.default.Component);
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(444);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Social = function (_React$Component) {
	    _inherits(Social, _React$Component);
	
	    function Social() {
	        _classCallCheck(this, Social);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Social.prototype.render = function render() {
	        return _react2.default.createElement(
	            'nav',
	            { className: 'level is-mobile' },
	            _react2.default.createElement(
	                'div',
	                { className: 'level-left' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'level-item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'icon is-small' },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'github' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'level-item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'icon is-small' },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'facebook' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'level-item' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'icon is-small' },
	                        _react2.default.createElement(_reactFontawesome2.default, { name: 'twitter' })
	                    )
	                )
	            )
	        );
	    };
	
	    return Social;
	}(_react2.default.Component);
	
	exports.default = Social;
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(375);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Social = __webpack_require__(195);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopNav = function (_React$Component) {
	    _inherits(TopNav, _React$Component);
	
	    function TopNav() {
	        _classCallCheck(this, TopNav);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    TopNav.prototype.render = function render() {
	        return _react2.default.createElement(
	            'nav',
	            { className: 'navbar topNav is-fixed-top  is-bold', role: 'navigation', 'aria-label': 'main navigation' },
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-brand' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: 'title is-4 navbar-item', to: '/' },
	                    '@fibasile'
	                ),
	                _react2.default.createElement(_Social2.default, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'navbar-menu' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'navbar-end' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-item' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/' },
	                            'Blog'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-item' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/about' },
	                            'About'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-item' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/projects' },
	                            'Projects'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-item' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/radar' },
	                            'Radar'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'navbar-item' },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/contacts' },
	                            'Contacts'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TopNav;
	}(_react2.default.Component);
	
	exports.default = TopNav;
	module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fiore.b40c8a33.jpg";

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TopNav = __webpack_require__(196);
	
	var _TopNav2 = _interopRequireDefault(_TopNav);
	
	__webpack_require__(376);
	
	var _Bio = __webpack_require__(73);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	var _Hero = __webpack_require__(194);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var title = (0, _get2.default)(this, 'props.data.site.siteMetadata.hero.title');
	    var subtitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.hero.subtitle');
	    var header = void 0;
	    // if (location.pathname === '/') {
	    header = _react2.default.createElement(_TopNav2.default, null)
	    // <h1>
	    //   <Link to={'/'} >
	    //     @fibasile blog
	    //   </Link>
	    // </h1>
	    ;
	    var hero = void 0;
	    if (location.pathname === '/') {
	      hero = _react2.default.createElement(_Hero2.default, { title: title,
	        subtitle: subtitle });
	    } else if (location.pathname === '/about') {
	      hero = _react2.default.createElement(_Hero2.default, { title: 'About', subtitle: 'Learn more about me' });
	    } else if (location.pathname === '/radar') {
	      hero = _react2.default.createElement(_Hero2.default, { title: 'On my radar', subtitle: 'Stuff worth bookmarking, in chronological order' });
	    } else if (location.pathname === '/projects') {
	      hero = _react2.default.createElement(_Hero2.default, { title: 'Projects', subtitle: 'Check out my work, open source software and projects' });
	    }
	    var sidebar = void 0;
	    if (location.pathname === '/') {
	      sidebar = _react2.default.createElement(
	        'div',
	        { className: 'column is-one-third' },
	        _react2.default.createElement(_Bio2.default, null)
	      );
	    }
	
	    // } else {
	    //   header = (
	    //     <h3>
	    //       <Link to={'/'}>
	    //         @fibasile blog
	    //       </Link>
	    //     </h3>
	    //   )
	    // }
	    return _react2.default.createElement(
	      'div',
	      null,
	      hero,
	      header,
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column' },
	              children()
	            ),
	            sidebar
	          )
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Template;

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-71307475765c1f537a87.js